// extracted by mini-css-extract-plugin
export default {"title":"Text_title__oHpl2"};